import React from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableVisitor } from './VariableVisitor';
import { postVisitor } from '../../store/Actions/ActionVisitor';
import '../../assets/styles/StylePopup.css'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../components/general/general-component/abstruct-component/AbstructForm';

function AddVisitor({ open, setOpen }) {
  
  const { mode, dispatch,langLocal } = AbstructVar();
  const { translate } = AbstructLang();
  const { state, setStateCustom, setLoad } = VariableVisitor();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postVisitor(state, setLoad));
  };

  // Define the form fields and labels
  const formFields = [
    { name: 'first_name', label: 'first_name', iconType: 'user', type: 'text' , inputType : 'text' },
    { name: 'last_name', label: 'last_name', iconType: 'user', type: 'text' , inputType : 'text' },
    { name: 'email', label: 'email', iconType: 'envelope', type: 'email' , inputType : 'text' },
    { name: 'phone_number', label: 'phone_number', iconType: 'phone', type: 'text' , inputType : 'text' },
    { name: 'password', label: 'password', iconType: 'key', type: 'password' , inputType : 'text' },
  ];

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('addvisitor')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
      </div>
    </RModal>
  );
}

export default AddVisitor;